"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "text-black"
};
const _hoisted_2 = { class: "hidden lg:flex gap-2 font-bold uppercase p-3" };
const _hoisted_3 = { class: "flex w-full items-center" };
const _hoisted_4 = { class: "flex w-full items-center" };
const _hoisted_5 = {
    key: 0,
    class: "flex w-full items-center"
};
const _hoisted_6 = { class: "w-full text-right" };
const _hoisted_7 = {
    key: 1,
    class: "flex w-full items-center"
};
const _hoisted_8 = { class: "w-full text-right" };
const _hoisted_9 = { class: "flex w-full items-center" };
const _hoisted_10 = { class: "w-full text-right" };
const _hoisted_11 = { class: "flex w-full items-center" };
const _hoisted_12 = { class: "w-full text-right" };
const _hoisted_13 = {
    key: 2,
    class: "flex w-full items-center"
};
const _hoisted_14 = { class: "w-full text-right" };
const _hoisted_15 = { class: "flex w-full items-center" };
const _hoisted_16 = { class: "w-full text-right" };
const _hoisted_17 = ["id"];
const _hoisted_18 = { class: "flex gap-2 p-3 bg-white flex-col lg:flex-row" };
const _hoisted_19 = { class: "flex w-full items-center border-b-1 lg:border-0 border-gray py-3 lg:py-0" };
const _hoisted_20 = { class: "lg:hidden flex-[0_0_100px] uppercase" };
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = { class: "flex w-full items-center border-b-1 lg:border-0 border-gray py-3 lg:py-0" };
const _hoisted_23 = { class: "lg:hidden flex-[0_0_100px] uppercase" };
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = {
    key: 0,
    class: "flex w-full items-center justify-end border-b-1 lg:border-0 border-gray py-3 lg:py-0"
};
const _hoisted_26 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_27 = { class: "grow text-right" };
const _hoisted_28 = {
    key: 1,
    class: "flex w-full items-center justify-end border-b-1 lg:border-0 border-gray py-3 lg:py-0"
};
const _hoisted_29 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_30 = { class: "grow text-right" };
const _hoisted_31 = { class: "flex w-full items-center justify-end border-b-1 lg:border-0 border-gray py-3 lg:py-0" };
const _hoisted_32 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_33 = { class: "grow text-right" };
const _hoisted_34 = { class: "flex w-full items-center justify-end border-b-1 lg:border-0 border-gray py-3 lg:py-0" };
const _hoisted_35 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_36 = { class: "flex grow justify-end" };
const _hoisted_37 = { class: "flex flex-row gap-0" };
const _hoisted_38 = ["id", "data-id", "value", "onKeyup"];
const _hoisted_39 = ["id", "onClick"];
const _hoisted_40 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-refresh" }, null, -1);
const _hoisted_41 = [
    _hoisted_40
];
const _hoisted_42 = ["id", "onClick"];
const _hoisted_43 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-trash" }, null, -1);
const _hoisted_44 = [
    _hoisted_43
];
const _hoisted_45 = {
    key: 2,
    class: "flex w-full items-center justify-end border-b-1 lg:border-0 border-gray py-3 lg:py-0"
};
const _hoisted_46 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_47 = { class: "grow text-right" };
const _hoisted_48 = { class: "flex w-full items-center justify-end py-3 lg:py-0" };
const _hoisted_49 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_50 = { class: "grow text-right" };
const _hoisted_51 = {
    key: 0,
    class: "flex gap-2 p-3 bg-white flex-col lg:flex-row border-dashed border-t-1 border-gray"
};
const _hoisted_52 = { class: "xl:grow flex w-full items-center border-b-1 lg:border-0 border-gray py-3 lg:py-0" };
const _hoisted_53 = { class: "lg:hidden flex-[0_0_100px] uppercase" };
const _hoisted_54 = { class: "grow text-right lg:text-left font-normal" };
const _hoisted_55 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "relative top-0.5 marso-icon-recycle text-green pr-1" }, null, -1);
const _hoisted_56 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<div class=\"hidden lg:flex w-full items-center border-b-1 lg:border-0 border-gray py-3 lg:py-0\"><div class=\"grow text-right lg:text-left\"></div></div><div class=\"hidden lg:flex w-full items-center border-b-1 lg:border-0 border-gray py-3 lg:py-0\"><div class=\"grow text-right lg:text-left\"></div></div><div class=\"hidden lg:flex w-full items-center border-b-1 lg:border-0 border-gray py-3 lg:py-0\"><div class=\"grow text-right lg:text-left\"></div></div><div class=\"hidden lg:flex w-full items-center border-b-1 lg:border-0 border-gray py-3 lg:py-0\"><div class=\"grow text-right lg:text-left\"></div></div>", 4);
const _hoisted_60 = { class: "flex w-full items-center justify-end border-b-1 lg:border-0 border-gray py-3 lg:py-0" };
const _hoisted_61 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_62 = { class: "grow text-right font-normal" };
const _hoisted_63 = {
    key: 0,
    class: "flex w-full items-center justify-end border-b-1 lg:border-0 border-gray py-3 lg:py-0"
};
const _hoisted_64 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_65 = { class: "grow text-right" };
const _hoisted_66 = { class: "font-normal" };
const _hoisted_67 = { class: "flex w-full items-center justify-end py-3 lg:py-0" };
const _hoisted_68 = { class: "lg:hidden flex-[0_0_100px] font-bold uppercase" };
const _hoisted_69 = { class: "grow text-right" };
const _hoisted_70 = { class: "font-normal" };
const _hoisted_71 = {
    key: 1,
    class: "flex px-3 bg-[#e1e1e1] py-[2px]"
};
const _hoisted_72 = { class: "grow flex justify-end font-bold" };
const _hoisted_73 = { class: "flex flex-wrap gap-2" };
const _hoisted_74 = { key: 0 };
const _hoisted_75 = { key: 1 };
const _hoisted_76 = { key: 2 };
const _hoisted_77 = { key: 3 };
const _hoisted_78 = { key: 4 };
const _hoisted_79 = { key: 5 };
const _hoisted_80 = { key: 6 };
const _hoisted_81 = { key: 7 };
const _hoisted_82 = { key: 0 };
const _hoisted_83 = { key: 8 };
const _hoisted_84 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_85 = {
    key: 0,
    class: "flex p-3 border-b-2 border-[#c1c1c1]"
};
const _hoisted_86 = { class: "grow font-bold" };
const _hoisted_87 = { class: "flex-[0_0_125px] text-right" };
const _hoisted_88 = { class: "flex p-3 border-b-2 border-[#c1c1c1]" };
const _hoisted_89 = { class: "grow font-bold" };
const _hoisted_90 = { class: "flex-[0_0_125px] text-right" };
const _hoisted_91 = {
    key: 1,
    class: "flex p-3 border-b-2 border-[#c1c1c1]"
};
const _hoisted_92 = { class: "grow font-bold" };
const _hoisted_93 = { class: "flex-[0_0_125px] text-right" };
const _hoisted_94 = { class: "flex p-3 border-b-2 border-[#c1c1c1]" };
const _hoisted_95 = { class: "grow font-bold" };
const _hoisted_96 = { class: "flex-[0_0_125px] text-right font-bold" };
const vue_3 = require("vue");
const shop_1 = require("../../common/utils/shop");
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const securityStore_1 = require("../../stores/security/securityStore");
const customDesignStore_1 = require("../../stores/customDesign/customDesignStore");
const cartsStore_1 = require("../../stores/carts/cartsStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartSummary',
    props: {
        hideStockInfoRefreshButton: {
            type: Function,
            default: () => { }
        }
    },
    setup(__props) {
        const props = __props;
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const activeCart = (0, vue_3.computed)(() => cartsStore.activeCart);
        const activeCartProducts = (0, vue_3.computed)(() => {
            return activeCart.value === undefined ? [] : activeCart.value.products;
        });
        const customerCurrencyCode = (0, vue_3.computed)(() => {
            if (securityStore.authenticatedUser !== null) {
                return securityStore.authenticatedUser.customer.currencyCode;
            }
            return "";
        });
        const inputRefs = (0, vue_3.ref)([]);
        const updateProductQuantity = (productId) => {
            let div = inputRefs.value.find((item) => {
                return (item.querySelector(`[data-id="${productId}"]`) instanceof
                    HTMLInputElement);
            });
            //megfelelő productId-hez tartozó inputot olvassuk ki
            let input = div.querySelector(`[data-id="${productId}"]`);
            if (!(input instanceof HTMLInputElement)) {
                return;
            }
            let quantity = parseInt(input.value);
            if (0 >= quantity) {
                cartsStore
                    .removeProduct(router, productId).then(() => {
                    refreshStockInfos();
                }).catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
                return;
            }
            cartsStore
                .updateProductQuantity(router, productId, quantity).then(() => {
                refreshStockInfos();
            }).catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        const removeProduct = (productId) => {
            var _a;
            if (activeCart.value === undefined) {
                return;
            }
            const gtagData = {
                currency: activeCart.value.getCurrencyCode(),
                value: activeCart.value.getNetTotal(),
                items: (_a = activeCart.value.products) === null || _a === void 0 ? void 0 : _a.map((product) => {
                    return {
                        item_id: product.id,
                        item_name: product.name,
                        price: product.priceNet,
                        quantity: product.quantity,
                    };
                }),
            };
            cartsStore
                .removeProduct(router, productId)
                .then(() => {
                gtag("event", "remove_from_cart", gtagData);
            })
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        const refreshStockInfos = () => {
            cartsStore.refreshStockInfos(router).then(() => {
                if (props.hideStockInfoRefreshButton) {
                    props.hideStockInfoRefreshButton();
                }
            }).catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d;
            return ((0, vue_2.unref)(activeCart) !== undefined && ((_a = (0, vue_2.unref)(activeCart)) === null || _a === void 0 ? void 0 : _a.getSize()) > 0)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_name", "Name", "carts")), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('cart_summary_size', 'Size', 'carts')), 1)
                        ]),
                        (!((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)) && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_net_price_list", "Net price list", "carts")), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (!((_c = (0, vue_2.unref)(currentUser)) === null || _c === void 0 ? void 0 : _c.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)) && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_discount", "Discount", "carts")), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)(!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive ?
                                (0, vue_2.unref)(i18n_1.trans)("cart_summary_net_price", "Net price", "carts") :
                                (0, vue_2.unref)(i18n_1.trans)("cart_summary_custom_price", "Custom price", "carts")), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_quantity", "Quantity", "carts")), 1)
                        ]),
                        (!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_net", "Total net", "carts")), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                            (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_gross", "Total gross", "carts")), 1)
                        ])
                    ]),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(activeCartProducts), (cartProduct, i) => {
                        var _a, _b;
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            id: `cart-summary-product-${cartProduct.id}`,
                            key: cartProduct.id,
                            ref_for: true,
                            ref_key: "inputRefs",
                            ref: inputRefs,
                            class: "mb-3"
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_name", "Name", "carts")), 1),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "grow text-right lg:text-left",
                                        innerHTML: cartProduct.getProductName()
                                    }, null, 8, _hoisted_21)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_size", "Size", "carts")), 1),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "grow text-right lg:text-left",
                                        innerHTML: cartProduct.getDetailsSize()
                                    }, null, 8, _hoisted_24)
                                ]),
                                (!((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)) && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_26, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_net_price_list", "Net price list", "carts")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((cartProduct.priceListNet + cartProduct.priceEco), (0, vue_2.unref)(customerCurrencyCode))), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (!((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)) && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_28, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_discount", "Discount", "carts")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_30, (0, vue_2.toDisplayString)((1 -
                                            cartProduct.priceNet / cartProduct.priceListNet).toLocaleString([], {
                                            style: "percent",
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                        })), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)(!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive ?
                                        (0, vue_2.unref)(i18n_1.trans)("cart_summary_net_price", "Net price", "carts") :
                                        (0, vue_2.unref)(i18n_1.trans)("cart_summary_custom_price", "Custom price", "carts")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_33, (0, vue_2.toDisplayString)(!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive ?
                                        (0, vue_2.unref)(shop_1.formatPrice)(cartProduct.priceNet, (0, vue_2.unref)(customerCurrencyCode)) :
                                        (0, vue_2.unref)(shop_1.formatPrice)((cartProduct.priceCustomNet + cartProduct.priceEco), (0, vue_2.unref)(customerCurrencyCode), { vatPercent: cartProduct.priceVatPercent })), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_35, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_quantity", "Quantity", "carts")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                            (0, vue_2.createElementVNode)("input", {
                                                id: `cart-summary-product-quantity-input-${i}`,
                                                class: "bg-[#cdcdcd] font-bold block w-16 !rounded-r-none py-1 px-2 placeholder-gray-dark text-lg text-center rounded-md outline-none transition-all duration-300 disabled:bg-gray",
                                                "data-id": cartProduct.id,
                                                type: "number",
                                                value: cartProduct.quantity,
                                                onKeyup: (0, vue_2.withKeys)(($event) => (updateProductQuantity(cartProduct.id)), ["enter"])
                                            }, null, 40, _hoisted_38),
                                            (0, vue_2.createElementVNode)("button", {
                                                id: `cart-summary-update-product-quantity-button-${i}`,
                                                class: "btn btn-rounded btn-primary !border-none !rounded-none !p-[8px]",
                                                type: "button",
                                                onClick: ($event) => (updateProductQuantity(cartProduct.id))
                                            }, _hoisted_41, 8, _hoisted_39),
                                            (0, vue_2.createElementVNode)("button", {
                                                id: `cart-summary-remove-product-button-${i}`,
                                                class: "btn btn-rounded btn-danger !rounded-l-none !border-2 !border-l-0 !p-[8px]",
                                                type: "button",
                                                onClick: ($event) => (removeProduct(cartProduct.id))
                                            }, _hoisted_44, 8, _hoisted_42)
                                        ])
                                    ])
                                ]),
                                (!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_45, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_46, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_net", "Total net", "carts")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_47, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((cartProduct.priceNet + cartProduct.priceEco) * cartProduct.quantity, (0, vue_2.unref)(customerCurrencyCode))), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_48, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_49, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_gross", "Total gross", "carts")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_50, [
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive ?
                                            (0, vue_2.unref)(shop_1.formatPrice)((cartProduct.priceNet + cartProduct.priceEco) * cartProduct.quantity, (0, vue_2.unref)(customerCurrencyCode), { vatPercent: cartProduct.priceVatPercent }) :
                                            (0, vue_2.unref)(shop_1.formatPrice)(cartProduct.priceCustomNet * cartProduct.quantity, (0, vue_2.unref)(customerCurrencyCode), { vatPercent: cartProduct.priceVatPercent })), 1)
                                    ])
                                ])
                            ]),
                            (cartProduct.priceEpr && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_51, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_52, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_53, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_name", "Name", "carts")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                            _hoisted_55,
                                            (0, vue_2.createTextVNode)("️" + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_epr_price", "EPR price", "carts")), 1)
                                        ])
                                    ]),
                                    _hoisted_56,
                                    (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_61, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_quantity", "Quantity", "carts")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_62, [
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatUnit)(cartProduct.weight * cartProduct.quantity, { unit: 'kg' })), 1)
                                        ])
                                    ]),
                                    (!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_63, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_64, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_net", "Total net", "carts")), 1),
                                            (0, vue_2.createElementVNode)("div", _hoisted_65, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_66, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(cartProduct.priceEpr * cartProduct.quantity, cartProduct.currencyCode)), 1)
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_68, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_total_gross", "Total gross", "carts")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_69, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_70, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(cartProduct.priceEpr * cartProduct.quantity, cartProduct.currencyCode, { vatPercent: cartProduct.priceVatPercent })), 1)
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (cartProduct.stockInfo)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_71, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["font-bold", {
                                                'text-red': 'noData' === cartProduct.stockInfo.status,
                                                'text-green-dark': 'available' === cartProduct.stockInfo.status,
                                                'text-red-dark': 'notAvailable' === cartProduct.stockInfo.status,
                                            }])
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_stock_info", "Stock info", "carts")), 3),
                                    (0, vue_2.createElementVNode)("div", _hoisted_72, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                            ('noData' === cartProduct.stockInfo.status)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_74, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_no_data", "No data", "carts")), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.expressStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_75, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("express_stock", "Express stock", "carts")) + ": " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.expressStock), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.localStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_76, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_local_stock", "Local stock", "carts")) + ": " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.localStock), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.localWholesaleStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_77, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("wholesale_stock", "Wholesale stock", "carts")) + ": " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.localWholesaleStock), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.centralStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_78, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("central_stock", "Central stock", "carts")) + ": " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.centralStock), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.otherSitesStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_79, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("other_sites_stock", "Other sites stock", "carts")) + ": " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.otherSitesStock), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.hungarianStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_80, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("hungarian_stock", "HUN stock", "carts")) + ": " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.hungarianStock), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.supplierStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_81, [
                                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_supplier_stock", "Supplier stock", "carts")) + " : " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.supplierStock), 1),
                                                    (cartProduct.stockInfo.supplierDate)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_82, " (" + (0, vue_2.toDisplayString)(cartProduct.stockInfo.supplierDateInDays) + ") ", 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (cartProduct.stockInfo.notAvailableStock)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_83, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_not_available_quantity", "Not available quantity", "carts")) + ": " + (0, vue_2.toDisplayString)(cartProduct.stockInfo.notAvailableStock), 1))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ], 8, _hoisted_17));
                    }), 128)),
                    ((0, vue_2.unref)(activeCart) !== undefined)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_84, [
                            ((0, vue_2.unref)(activeCart).getEcoTotal() > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_85, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_86, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_eco", "ECO", "carts")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_87, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getEcoTotal(), (0, vue_2.unref)(activeCart).getCurrencyCode())), 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_88, [
                                (0, vue_2.createElementVNode)("div", _hoisted_89, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_net_subtotal", "Net subtotal", "carts")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_90, (0, vue_2.toDisplayString)(!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive ?
                                    (0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getNetTotal(), (0, vue_2.unref)(customerCurrencyCode)) :
                                    (0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getCustomNetTotal(), (0, vue_2.unref)(customerCurrencyCode))), 1)
                            ]),
                            (!((_d = (0, vue_2.unref)(currentUser)) === null || _d === void 0 ? void 0 : _d.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_91, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_92, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_vat", "VAT", "carts")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_93, (0, vue_2.toDisplayString)(!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive ?
                                        (0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getGrossTotal() - (0, vue_2.unref)(activeCart).getNetTotal() - (0, vue_2.unref)(activeCart).getEcoTotal(), (0, vue_2.unref)(customerCurrencyCode)) :
                                        (0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getCustomGrossTotal() -
                                            (0, vue_2.unref)(activeCart).getCustomNetTotal(), (0, vue_2.unref)(customerCurrencyCode))), 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_94, [
                                (0, vue_2.createElementVNode)("div", _hoisted_95, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("cart_summary_gross_total", "Gross total", "carts")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_96, (0, vue_2.toDisplayString)(!(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive ?
                                    (0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getGrossTotal(), (0, vue_2.unref)(customerCurrencyCode)) :
                                    (0, vue_2.unref)(shop_1.formatPrice)((0, vue_2.unref)(activeCart).getCustomGrossTotal(), (0, vue_2.unref)(customerCurrencyCode))), 1)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
